import { skipToken, useQuery } from "@apollo/client/react";
import { useContext } from "react";

import { UserContext } from "@/contexts/user-context";
import { IsUserFollowingDocument } from "@/graphql/codegen/graphql";

export const useUserFollowStatus = (publicKey?: string) => {
  const { user, loading: loadingUser } = useContext(UserContext);
  const shouldFetch = !!(
    user?.publicKey &&
    publicKey &&
    user.publicKey !== publicKey
  );

  const {
    data,
    loading: isUserFollowLoading,
    refetch,
  } = useQuery(
    IsUserFollowingDocument,
    shouldFetch
      ? {
          variables: {
            publicKey: publicKey!,
            filter: {
              followerFast: {
                publicKey: {
                  equalTo: user!.publicKey,
                },
              },
            },
            isUserFollowsCurrentAccountFilter: {
              followeeFast: {
                publicKey: {
                  equalTo: user!.publicKey,
                },
              },
            },
          },
        }
      : skipToken,
  );

  const followerPkid =
    data?.accountByPublicKey?.followersFast?.nodes[0]?.followerPkid ?? null;
  const isUserFollowedByPublicKey = followerPkid !== null;

  const isPublicKeyFollowedByUser =
    (data?.accountByPublicKey?.isUserFollowsCurrentAccount.nodes[0]
      ?.followerPkid ?? null) !== null;

  return {
    user,
    loadingUser,
    isUserFollowedByPublicKey,
    refetch,
    isUserFollowLoading,
    isPublicKeyFollowedByUser,
  };
};
